import * as process from "process";

export const environment = {
  BO_ENV: process.env['BO_ENV'] || 'local',
  oneTrustDomainScript: '0195a959-9ff7-7727-a943-8330b9af9fb6-test',
  zuora_url: "https://apisandbox.zuora.com/apps/PublicHostedPageLite.do",
  SDK_CONFIG: {
    monitoring: 'HIGH',
    credentials: {
      apiKey: "4_l3tjIWxerBLq96ME39BO8Q",
      enableCLP: false,
      fcaCognito: {
        getCognitoIdentityToken: {
          'path': '/v2/cognito/identity/token',
          'method': 'POST',
          'host': "https://authz.sdpr-02.prep.fcagcv.com",
          'headers': {
            'Content-Type': 'application/json',
            'x-api-key': '2rVctWlJz47M1GsL7o9ph2RPCqAzf57r7nYtdK1B',
            'locale': 'us_en',
            'region': "us-east-1",
            'x-originator-type': 'web',
            'x-clientapp-version': '1.0',
          }
        },
        cognito_sdpr_params: {
          'fcl_api_host': "https://mfa.fcl-02.prep.fcagcv.com",
          'fcl_api_key': "lHBEtsqT1Y5oKvzhvA9KW6rkirU3ZtGf44jTIiQV",
          'identity_token_path': "/v2/cognito/identity/token",
          'lambda_function_api_key': "2rVctWlJz47M1GsL7o9ph2RPCqAzf57r7nYtdK1B",
          'lambda_function_base_url': "https://authz.sdpr-02.prep.fcagcv.com",
          'mqtt_host': "agz8346qrixdz-ats.iot.us-east-1.amazonaws.com",
          'region': "us-east-1",
          'sdpr_sign_service': "execute-api",
          'sdpr_api_key': "2rVctWlJz47M1GsL7o9ph2RPCqAzf57r7nYtdK1B",
          'sdpr_api_key_disclaimer': "2rVctWlJz47M1GsL7o9ph2RPCqAzf57r7nYtdK1B",
          'sdpr_api_host': "https://channels.sdpr-02.prep.fcagcv.com",
          'version': "v1",
          'x_originator_type': "web",
        },
        spaceMWUrl: "https://api-web-preprod.space.awsmpsa.com"
      }
    },
    brand: 'jeep',
    appVersion: '1',
    countryCode: 'us',
    language: 'en',
    source: "SPACEWEB",
  }
};


